<template>
  <v-container fluid class="blog">
    <div class="d-flex justify-center flex-wrap">
      <div class="b-card mb-5" 
        v-for="value in Blogs.slice().reverse()" 
        :key="value.index">
        <router-link :to="value.link">
          <blog-card
            :url="value.url" 
            :urlPosition="value.urlPosition"
            :title="value.title"
            :subtitle="value.subtitle"
            :abstract="value.abstract"
            :date="value.date">
          </blog-card>
        </router-link>
      </div>
    </div>
  </v-container>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
import BlogCard from './BlogCard.vue';
import blogs from './Blogs.json';

export default {
  name: "BlogComponent",
  components: {BlogCard},
  data() {
    return {
      id: this.$route.params.id,
      Blogs: blogs,
      category: 'All',
      dropped: false,
    };
  },
  watch: { '$route'(to){ this.id = to.params.id; }},
  methods: {
    categoryIs: function (message) {
      this.category = message;
      this.dropped = !this.dropped;
    }
  }
}
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style scoped>
.blog{ margin: 100px 0;}
.b-card{
  position: relative;
  width: 37vw;
  margin: 1vw;
  min-width: 340px;
  max-width: 800px;
  height: auto;
}
</style>
